<template>
  <b-form>
    <b-row>
      <b-col lg="5">
        <!-- <b-form-group
          :state="!formValidatedState('product_images')"
          :invalid-feedback="apiErrors.product_images"
        >
          <img src="@/assets/images/actions/add-image.svg" alt="Add Image" :id="'add-image-' + key" />
            <b-popover
              :target="'add-image-' + key"
              triggers="hover"
              content="Add Image"
              placement="top"
            >
            </b-popover>
            <b-form-file
              plain
              accept=".jpg, .png, .gif"
              id="upload-product-images"
              class="position-absolute w-100"
              v-model="productImage"
              @input="getImages"
              ref="productImageUpload"
              v-if="productImages.length < 10"
            >
            </b-form-file>
          </div>
        </b-form-group> -->
        <b-form-group
          :state="!formValidatedState('product_images')"
          :invalid-feedback="apiErrors.product_images"
        >
        <!-- <div v-if="encodedGif">
          <h3>Generated GIF:</h3>
          <img :src="encodedGif" alt="Generated GIF" />

        </div> -->
    <!-- <div>
      <div v-for="(frame, index) in frames" :key="`frame_${index}`">
        <img :src="frame.imageCanvas">
      </div>
    </div> -->
          <div class="d-flex" >
             <div v-if="showAddImageButton" style="display: inline-flex; align-items: center; position: relative; cursor: pointer; margin-right: 16px;" :id="'add-image-' + idPopup" >
                <b-form-file
                  plain
                  accept=".jpg, .png, .gif"
                  v-model="productImage"
                  @input="getImages"
                  ref="productImageUpload"
                  v-if="productImages.length < 10"
                  :id="`productImageUploadInput` + idPopup"  style="display: none;"        >
                </b-form-file>
                <label :for="`productImageUploadInput` + idPopup"> <img
                    :id="'add-image-' + idPopup"
                    src="@/assets/images/actions/add-image.svg"
                    alt="Add Image"
                    style="width: 25px; height: 25px; cursor: pointer;"
                  />
                  <b-popover
                    :target="'add-image-' + idPopup"
                    triggers="hover"
                    content="Add Image"
                    placement="top"
                  >
                  </b-popover>
                </label>
              </div>

              <i
                class="action-btn"
                @click="showDeleteQuestionElementModal"
                v-if="contentElementsLength > 2 && showDeleteButton"
              >
                <img src="@/assets/images/actions/delete_new.svg" alt="Delete" :id="'delete-answer-' + idPopup" style="cursor: pointer;"/>
                <b-popover
                  :target="'delete-answer-' + idPopup"
                  triggers="hover"
                  content="Delete"
                  placement="top"
                >
                </b-popover>
              </i>
          </div>     
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapState } from "vuex";
import ImageUploadAnswer from "@/components/survey/ImageUploadAnswer";
import { productsMixins } from "@/mixins/products_mixins";
import notification from "@/services/notification";

export default {
  components: { ImageUploadAnswer},
  props: {
    imageData: {
      type: [Object,Array],
      default: () => {},
    },
    imageKey: {
      type: [Number,String],
      default: 0, // Set your default value here
    },
    contentElementsLength: {
      type: [Number,String],
      default: 0, // Default value for contentElementsLength
    },
    showDeleteButton: {
      type: Boolean,
      default: false, // Default value for showDeleteButton
    },
    showAddImageButton: {
      type: Boolean,
      default: true, // Default value for showDeleteButton
    },
    componentKey:{
      type: [Number,String],
      default: null
    },
    idPopup: {
      type: [Number,String],
      default: 0, // Set your default value here
    },
  },
  data() {
    return {
      message: "Recommended Size: 638 x 310px",
      product_img_upload: {
        croppa: {},
        sliderVal: 0,
        sliderMin: 0,
        sliderMax: 0,
      },
      chosenFile: null,
      productImage: null,
      imageAspectRatio: null,
      uploadedImage: null,
      imageDataKey: {},
    };
  },
  computed: {
    ...mapState("products", ["product_images", "errors"]),
    productImages() {
      return this.product_images.filter(image => image.action !== "delete");
    },
    gridRowCount: {
      get() {
        let row_count = 2;
        const images_count = this.product_images.length;
        if (images_count > 5 && images_count <= 9) row_count = 3;
        else if (images_count === 10) row_count = 4;

        return {
          "--row-count": row_count,
        };
      },
      set(count) {
        return count;
      },
    },
  },
  mixins: [productsMixins],
  methods: {
    async getImages(image) {
      const acceptedFileTypes = ["jpg", "jpeg", "png", "gif"];
      
      if (image) {
        try {

         

          const data = await this.getImageDimensions(image);
          this.imageAspectRatio = data.aspectRatio;

          const chosenFile = await this.getImageBase64(image);
          const prefix = chosenFile.match(/^data:image\/\w+;base64,/)[0]; // Extract prefix
          const base64String = chosenFile.replace(prefix, ""); // Remove prefix from data

          const uploadedImage = image.name.replace(/\.[^/.]+$/, "");
          const type = image.type.split("/").pop();
          if (acceptedFileTypes.includes(type)) {
            this.$emit("ImageData", {
              key: this.imageKey,
              base64: base64String,
              image: chosenFile,
              fileName: uploadedImage,
              aspectRatio: data.aspectRatio,
              width: data.width,
              height: data.height,
              fileType: type,
              rawFile: image,
              showImage: false
            });

            this.$root.$emit("bv::show::modal", `UploadImageAnswer${this.componentKey}`);
          } else {
            console.log("Invalid file type");
             
          }
        } catch (error) {
          this.$emit("reload")
          notification.warning("Invalid File Type");
        }
      }
    },

    getImageDimensions(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const width = img.width;
          const height = img.height;
          const aspectRatio = width / height;
          resolve({ width, height, aspectRatio });
        };
        img.onerror = reject;

        img.src = URL.createObjectURL(file); 
      });
    },
    getImageBase64(image, onLoadCallback) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(image);
      });
    },
    removeImage(imageIndex) {
      const product_image = this.product_images.find(image => image.index === imageIndex);
      this.$store.commit("products/removeImage", {
        action: "delete",
        index: imageIndex,
      });
    },
    isBase64Present(key) {
      return this.imageData && this.imageData[key] && this.imageData[key].base64 !== undefined && this.imageData[key].base64 !== null;
    },
    showDeleteQuestionElementModal() {
      this.$emit("showDeleteQuestionElementModal");
    },

  },
};
</script>

<style lang="scss" scoped>
.popover {
    background: #2f4858 !important;
    .popover-body {
        color: #ffffff !important;
    }
}
.product-images-container {
  border-radius: 12px;
  border: 1px dashed #d8dcde;
  font-size: 14px;
  color: #2f3941;
  & > strong {
    font-size: 14px;
  }
}
#upload-product-images {
  top: 0;
  left: 0;
  background: red;
  height: 45px;
  opacity: 0;
  cursor: pointer;
}
.uploaded-images-container {
  .single-img-container {
    .bi.bi-trash {
      width: 28px;
      height: 28px;
      top: 10px;
      right: 10px;
      color: #fff;
      background: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      display: none !important;
      transition: all 0.3s ease;
    }
    &:hover {
      .bi.bi-trash {
        display: inherit !important;
      }
    }
  }
  .grid-view {
    margin: auto;
    display: grid;
    grid-template-columns: repeat(4, 75px);
    grid-template-rows: repeat(var(--row-count), 75px);
    gap: 10px;
    .single-img-container {
      &:first-child {
        grid-column-start: 1;
        grid-column-end: span 2;
        grid-row-start: 1;
        grid-row-end: span 2;
      }
      &:nth-child(10) {
        grid-column-start: 3;
        grid-column-end: span 2;
        grid-row-start: 3;
        grid-row-end: span 2;
      }
    }
  }
}
</style>
